/**
 * Auto-generated by: https://github.com/pmndrs/gltfjsx
 * Command: npx gltfjsx@6.5.0 orion_9slotrack.glb -T 
 * Files: orion_9slotrack.glb [64.62MB] > C:\Users\eduardo.vieira\frontendOrion\public\models\orion_9slotrack-transformed.glb [3.11MB] (95%)
 */

import React from 'react'
import { useGLTF } from '@react-three/drei'

/**
 * Rack9slot component renders a 3D model of a 9-slot rack.
 * 
 * @component
 * @param {object} pos - The position of the 9-slot rack model.
 * @returns {React.ReactElement} The Rack9slot component.
 */
export function Rack9slot(pos) {
  /**
   * Uses the useGLTF hook to load the 9-slot rack 3D model.
   * 
   * @type {object} nodes - The nodes of the 3D model.
   * @type {object} materials - The materials of the 3D model.
   */
  const { nodes, materials } = useGLTF('/models/orion_9slotrack-transformed.glb')

  return (
    <group position={[122,-10.5,1.8]} dispose={null} rotation={[Math.PI/2,0,0]} >
      <mesh geometry={nodes.orion_9slotrack_EMPTY.geometry} material={nodes.orion_9slotrack_EMPTY.material} />
    </group>
  )
}

/**
 * Preloads the 9-slot rack 3D model.
 */
useGLTF.preload('/models/orion_9slotrack-transformed.glb')